import { useRef, useCallback } from "react";
const useFunction = (callback) => {
  const callbackRef = useRef(callback);
  callbackRef.current = callback;
  return useCallback((...args) => {
    return callbackRef.current(...args);
  }, []);
};
export {
  useFunction
};
//# sourceMappingURL=main13.mjs.map
